/**
 * @fileOverview If a user arriving at the app is already logged in, we can ask
 * the backend if he has a service request in progress. If so, we can redirect
 * the user to the last valid step in the booking funnel. Otherwise, we can send
 * them directly to “my caregivers”.
 */

import { getLastFinishedStep } from '@/mixins/lastFinishedStep'
import store from '@/store'

const logger = require('debug')('careship:redirect-user')

export default async function getPathToRedirectLoggedInUser(): Promise<
  '/buchungsstatus/uebersicht' | '/meine-alltagshelfer'
> {
  logger('checking whether the user should be redirected')

  await store.dispatch('status/checkCustomerStatus')

  const draft = store.getters['status/getServiceRequestDraft']
  const lastFinishedStep = getLastFinishedStep(draft)

  logger('lastFinishedStep: %s', lastFinishedStep)
  logger('lastFinishedStep -> has draft? -> %O', draft || false)

  if (Object.entries(draft).length !== 0 && lastFinishedStep !== 'payment') {
    return '/buchungsstatus/uebersicht'
  }

  return '/meine-alltagshelfer'
}
